<template>
  <div>
    <v-dialog v-model="isOpen" persistent max-width="500">
      <v-card class="align-center">
        <v-card-title>
          <div class="d-flex align-center justify-space-between w-100">
            <div />
            <h1 class="text-center">Editar Pagamento</h1>
            <v-btn icon @click="close" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text v-if="isLoading" class="py-12 d-flex align-center justify-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-card-text>
        <v-card-text v-else class="mt-4 text-center">
          <span>Insira o número de recebimento / transferência para concluir a ação</span>
          <v-row class="mt-5 d-flex justify-center mx-auto">
            <v-col cols="12">
              <v-text-field v-model="invoice.receiptNumber" label="N° Recebimento"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="invoice.externalInvoiceNumber" label="Id da Fatura Externa"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-5 mx-auto">
            <v-col cols="12" md="6">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedInvoiceDate"
                    label="Data da Fatura"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="invoice.invoiceDate"
                  :active-picker.sync="activePicker"
                  locale="pt-br"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedReceiptForecast"
                    label="Data de previsão"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="invoice.receiptForecast"
                  :active-picker.sync="activePicker"
                  locale="pt-br"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedPaymentReceived"
                    label="Data de recebimento"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="invoice.paymentReceived"
                  :active-picker.sync="activePicker"
                  locale="pt-br"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="mt-5 d-flex justify-center mx-auto">
            <v-col cols="12">
              <v-textarea v-model="invoice.observation" rows="3" label="Observação"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex pb-4 px-5">
          <v-btn class="flex-grow-1" color="error" large @click="close"> Cancelar </v-btn>
          <v-btn
            class="flex-grow-1"
            color="success"
            large
            :loading="isEditButtonLoading"
            @click="editInvoiceReceivable()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MessagesError from '@/components/MessagesError.vue';

export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    invoiceToEdit: {
      default: () => ({
        id: null,
        receiptNumber: null,
        externalInvoiceNumber: null,
        invoiceDate: null,
        receiptForecast: null,
        paymentReceived: null,
        observation: null
      }),
      type: Object
    }
  },

  components: {
    MessagesError
  },

  data: () => ({
    isLoading: false,
    isEditButtonLoading: false,
    menu: false,
    menu1: false,
    menu2: false,
    activePicker: null,
    invoice: {
      id: null,
      receiptNumber: null,
      externalInvoiceNumber: null,
      invoiceDate: null,
      receiptForecast: null,
      paymentReceived: null,
      observation: null
    },
    errors: [],
    errorsType: 'error',
    error500: null
  }),

  computed: {
    formattedInvoiceDate() {
      const invoiceDate = this.invoice.invoiceDate;
      if (!invoiceDate) return '';
      const [year, month, day] = this.invoice.invoiceDate.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedPaymentReceived() {
      const paymentReceived = this.invoice.paymentReceived;
      if (!paymentReceived) return '';
      const [year, month, day] = this.invoice.paymentReceived.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedReceiptForecast() {
      const receiptForecast = this.invoice.receiptForecast;
      if (!receiptForecast) return '';
      const [year, month, day] = this.invoice.receiptForecast.split('-');
      return `${day}/${month}/${year}`;
    }
  },

  watch: {
    isOpen: {
      async handler(isOpen) {
        if (isOpen) {
          this.isLoading = true;

          const {
            id,
            receiptNumber,
            externalInvoiceNumber,
            invoiceDate: invoiceDateToFormat,
            receiptForecast: receiptForecastToFormat,
            paymentReceived: dateToFormat,
            observation
          } = this.invoiceToEdit;

          const invoiceDate = invoiceDateToFormat.slice(0, 10);
          const receiptForecast = receiptForecastToFormat.slice(0, 10);

          let paymentReceived = null;
          if (dateToFormat) {
            paymentReceived = dateToFormat.slice(0, 10);
          }

          this.invoice = {
            id,
            receiptNumber,
            externalInvoiceNumber,
            invoiceDate,
            receiptForecast,
            paymentReceived,
            observation
          };
        }
        this.isLoading = false;
      }
    }
  },

  methods: {
    ...mapActions('InvoicesReceivableStore', ['updateInvoiceReceivable']),

    async editInvoiceReceivable() {
      try {
        this.isEditButtonLoading = true;

        const data = await this.updateInvoiceReceivable(this.invoice);
        if (data.success) {
          this.handleSuccessFeedback();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (e) {
        console.error(e);
        this.errors = ['Opss, algo deu errado!'];
        this.errorsType = 'error';
      } finally {
        this.isEditButtonLoading = false;
        this.close();
      }
    },

    handleSuccessFeedback() {
      this.errors = ['Fatura editada com sucesso!'];
      this.errorsType = 'success';
      this.$emit('shouldUpdateList');
      this.close();
    },

    close() {
      this.reset();
      this.$emit('update:isOpen', false);
    },

    reset() {
      this.invoice = {
        id: null,
        receiptNumber: null,
        externalInvoiceNumber: null,
        receiptForecast: null,
        paymentReceived: null,
        observation: null
      };
    }
  }
};
</script>
